<template>
  <div class="forced-spirometry">
    <!-- Header dropdown filter -->
    <b-row>
      <b-colxx xxs="12" class="mb-4 pl-0">
        <header-drop-down-filter
          :leftHeaderText="leftHeaderTextValue"
          :sites="allSitesList"
          :countries="countryList"
          :callApiCompleted="callApiCompleted"
          :checkedSitesApply="sitesSelected == 'all' ? allSitesList : sitesSelected"
          :checkedCountriesApply="countrySelected == 'all' ? countryList : countrySelected"
          :exportBtn="false"
          :participantsBtn="true"
          :todayDate="todaysDate"
          @onApplyCountry="onFilterCountry"
          @onApplySites="onFilterSites"
          @onApplyParticipants="onFilterParticipants"
          @onFetchedParticipants="fetchedParticipants"
          @onApplyFpi="filter"
          :dataPicker="dataPicker"
          @onApplyRangeMonth="getRangeMonth"
          :specificSiteId="specificSiteId"
          :zoomGraphValue="zoomGraphValue"
          :settingsBtn="false"
          :siteListInParticipants="siteListInParticipants"
          v-if="studyData"
          ref="headerDropdownFilter"
          :studyData="studyData"
        ></header-drop-down-filter>
      </b-colxx>
    </b-row>
    <!-- End header dropdown filter -->

    <!-- Only show when zoomGraph -->
    <div v-if="zoomGraphValue" @click="zoomGraphValue = ''" class="mb-10 color_4c8ce4 expand-back">
      <i class="fa fa-caret-left" aria-hidden="true"></i>
      Back
    </div>
    <!-- End show when zoomGraph -->

    <b-row class="mt-3" v-show="zoomGraphValue === '' || zoomGraphValue === 'expected-data' || zoomGraphValue === 'daily-spirometer-reading'">
      <b-colxx :class="zoomGraphValue === 'expected-data' ? 'col-sm-12 expected-data-zoom' : 'col-sm-6'" v-show="zoomGraphValue === '' || zoomGraphValue === 'expected-data'" class="pl-0 pb-10" style="transition-duration: 0.2s">
        <expected-data titleChart="Expected Data" downloadId="expected-data" :zoomGraphValue="zoomGraphValue" @zoomEnabled="zoomEnabled('expected-data')" @zoomDisabled="zoomDisabled" :studyID="studyId" :dataLoaded="dataLoaded.expectedData" :fields="expectedDataFields" :items="expectedDataItems"> </expected-data>
      </b-colxx>

      <b-colxx :class="zoomGraphValue === 'daily-spirometer-reading' ? 'col-sm-12 daily-spirometer-reading-zoom' : 'col-sm-6'" v-show="zoomGraphValue === '' || zoomGraphValue === 'daily-spirometer-reading'" class="pl-0 pb-10">
        <daily-spirometer-reading
          titleChart="Daily Spirometer Readings"
          downloadId="daily-spirometer-reading"
          :zoomGraphValue="zoomGraphValue"
          @zoomEnabled="zoomEnabled('daily-spirometer-reading')"
          @zoomDisabled="zoomDisabled"
          :studyID="studyId"
          :dataLoaded="dataLoaded.dailySpirometerReading"
          :rawData="dailySpirometerReadingRawData"
          :countrySelected="countrySelected"
          :sitesSelected="sitesSelected"
          :analyteFilters="analyteFilters"
        >
        </daily-spirometer-reading>
      </b-colxx>
    </b-row>

    <b-row class="mt-5" v-show="zoomGraphValue === '' || zoomGraphValue === 'recent-data'">
      <b-colxx :class="zoomGraphValue === 'recent-data' ? 'col-sm-12 recent-data-zoom' : 'col-sm-12'" v-show="zoomGraphValue === '' || zoomGraphValue === 'recent-data'" class="pl-0 pb-10" style="transition-duration: 0.2s">
        <recent-data titleChart="Recent Data" downloadId="recent-data" :zoomGraphValue="zoomGraphValue" @zoomEnabled="zoomEnabled('recent-data')" @zoomDisabled="zoomDisabled" :studyID="studyId" :dataLoaded="dataLoaded && dataLoaded.recentData" :fields="recentDataFields" :items="recentDataItems" :infiniteScroll="false" @onScrollRecentDataTable="onScrollRecentDataTable"> </recent-data>
      </b-colxx>
    </b-row>
  </div>
</template>

<script>
import Vue from "vue";
import Loading from "vue-loading-overlay";
import HeaderDropDownFilter from "@/components/form-components/header-drop-down-filter";
import { mapGetters } from "vuex";
import moment from "moment";
import _get from "lodash/get";
import _ from "lodash";
import ExpectedRecentData from "@/components/containers/expected-recent-data";
import DailySpirometerReading from "@/components/containers/daily-spirometer-readings";
import * as utils from "@/services/visualization/utils";
import * as forcedSpirometryService from "@/services/visualization/forced-spirometry";
import _isEmpty from "lodash/isEmpty";

Vue.use(Loading);

export default {
  name: "forced-spirometry",

  components: {
    HeaderDropDownFilter,
    ExpectedData: ExpectedRecentData,
    RecentData: ExpectedRecentData,
    DailySpirometerReading
  },
  props: {
    studyData: { type: Object, default: null }
  },
  data() {
    return {
      studyId: null,
      leftHeaderTextValue: "Forced Spirometry",
      allSitesList: [],
      countryList: [],
      callApiCompleted: null,
      sitesSelected: ["all"],
      countrySelected: "all",
      participantsSelected: ["all"],
      siteListInParticipants: [],
      dataPicker: [],
      specificSiteId: null,
      zoomGraphValue: "",
      expectedRawData: [],
      recentRawData: [],
      expectedDataFields: [],
      expectedDataItems: [],
      recentDataFields: [],
      recentDataItems: [],
      dataLoaded: {},
      isLoading: true,
      tmpCountries: [],
      tmpSites: [],
      dailySpirometerReadingRawData: [],
      fromDate: null,
      toDate: null,
      analyteFilters: [],
      siteIdNameMaps: [],
      countrySiteMaps: [],
      selectedSiteIds: [],
      todaysDate: "",
      allParticipantSiteIds: [],
      activityId: null,
      pageSize: 10,
      pageNum: 0
    };
  },
  methods: {
    onFilterCountry(payload) {
      this.pageNum = 0;
      this.filter("country", payload.isCheckAll ? "all" : payload.checked);
    },

    onFilterSites(payload) {
      this.pageNum = 0;
      this.filter("site", payload.isCheckAll ? "all" : payload.checked);
    },

    onFilterParticipants(payload) {
      this.pageNum = 0;
      this.filter("participant", payload.isCheckAll ? "all" : payload);
    },

    fetchedParticipants(payload) {
      this.siteListInParticipants = payload;
    },

    getRangeMonth(payload) {
      this.pageNum = 0;
      this.filter("date", payload);
    },

    async filter(triggerBy, filterValue) {
      switch (triggerBy) {
        case "country": {
          this.countrySelected = filterValue;
          const countrySelected = filterValue === "all" ? this.countryList : filterValue;
          const selectedSites = utils.getSitesWhenFilteringCountry(this.countrySiteMaps, countrySelected);
          this.sitesSelected = filterValue === "all" ? ["all"] : selectedSites;
          this.selectedSiteIds = utils.getSiteIdsBySiteNames(this.siteIdNameMaps, this.sitesSelected);
          if (this.sitesSelected && this.sitesSelected.length === 0) {
            this.setToEmptyData();
            return;
          }
          break;
        }

        case "site": {
          this.sitesSelected = filterValue === "all" ? ["all"] : filterValue;
          this.selectedSiteIds = utils.getSiteIdsBySiteNames(this.siteIdNameMaps, this.sitesSelected);
          if (this.sitesSelected && this.sitesSelected.length === 0) {
            this.setToEmptyData();
            return;
          }
          break;
        }

        case "date": {
          this.monthSelected = filterValue;

          this.fromDate = this.fromDate = filterValue[0].value;
          this.toDate = this.toDate = filterValue[1].value;

          if (this.fromDate === this.firstFromDate && this.toDate === this.firstToDate) {
            this.fromDate = null;
            this.toDate = null;
          }
          break;
        }

        case "participant": {
          this.participantsSelected = filterValue === "all" ? ["all"] : filterValue.checkedParticipants;
          if (this.participantsSelected && this.participantsSelected.length === 0) {
            this.setToEmptyData();
            return;
          }
          break;
        }
        default:
          break;
      }
      this.callApi(true, triggerBy);
      this.filterTriggered = !this.filterTriggered;
    },

    setToEmptyData() {
      this.expectedDataItems = [];
      this.recentDataItems = [];
      this.dailySpirometerReadingRawData = [];
    },

    async prepareDatePicker() {
      const d = new Date();
      this.todaysDate = moment.utc(d).format("DD MMM YYYY");
      const studyData = this.studyData;
      const studyStartDate = studyData.studyStartDate;
      const datePicker = [];
      for (let m = moment(studyStartDate); m.diff(moment(), "months") <= 0; m.add(1, "months")) {
        datePicker.push(m.format("MMM YYYY"));
      }
      this.dataPicker = datePicker;
      const firstMonth = this.dataPicker[0];
      const lastMonth = this.dataPicker[this.dataPicker.length - 1];
      this.monthSelected = [firstMonth, lastMonth];
    },

    async turnOffGlobalLoader() {
      const query = Object.assign({}, this.$route.query);
      delete query.automatic_off_loader;
      this.$router.replace({ query });
      this.$store.commit("SHOW_LOADER", false);
    },

    async getExpectedData() {
      this.isLoading = true;

      let response = null;
      const params = {
        studyId: this.studyId
      };

      const body = {};

      if (this.fromDate) {
        body.fromDate = this.fromDate;
        body.toDate = this.toDate;
      }

      if (this.participantsSelected && this.participantsSelected[0] !== "all") {
        body.participantsIds = this.participantsSelected;
      }

      if (this.selectedSiteIds && this.selectedSiteIds.length > 0 && this.selectedSiteIds[0] !== "all") {
        body.siteIds = this.selectedSiteIds;
      }

      if (this.specificSiteId.length > 0) {
        if (body.sitesIds && body.siteIds.length > 0) {
          body.siteIds.push(this.specificSiteId[0]);
        } else {
          body.siteIds = this.specificSiteId;
        }
      }

      body.activityId = this.activityId;

      //Api endpoint call
      const data = await this.$api.getExpectedData(params, body);

      if (data.ok) {
        const result = data.body;

        if (result.data.length > 0) {
          response = result.data;
        }
      }

      this.isLoading = false;
      return response;
    },

    async getRecentData() {
      this.isLoading = true;

      let response = null;
      const params = {
        studyId: this.studyId
      };

      const body = {};

      if (this.fromDate) {
        body.fromDate = this.fromDate;
        body.toDate = this.toDate;
      }

      if (this.participantsSelected && this.participantsSelected[0] !== "all") {
        body.participantsIds = this.participantsSelected;
      }

      if (this.selectedSiteIds && this.selectedSiteIds.length > 0 && this.selectedSiteIds[0] !== "all") {
        body.siteIds = this.selectedSiteIds;
      }

      if (this.specificSiteId.length > 0) {
        if (body.sitesIds && body.siteIds.length > 0) {
          body.siteIds.push(this.specificSiteId[0]);
        } else {
          body.siteIds = this.specificSiteId;
        }
      }

      body.activityId = this.activityId;

      //Api endpoint call
      const data = await this.$api.getRecentData(params, body);

      if (data.ok) {
        const result = data.body;

        if (result.data !== {}) {
          response = result.data;
        }
      }

      this.isLoading = false;
      return response;
    },

    async getDailySpirometerReadingData() {
      let response = null;
      const params = {
        studyId: this.studyId
      };

      const body = {};

      if (this.fromDate) {
        body.fromDate = this.fromDate;
        body.toDate = this.toDate;
      }

      if (this.participantsSelected && this.participantsSelected[0] !== "all") {
        body.participantsIds = this.participantsSelected;
      }

      if (this.selectedSiteIds && this.selectedSiteIds.length > 0 && this.selectedSiteIds[0] !== "all") {
        body.siteIds = this.selectedSiteIds;
      }

      if (this.specificSiteId.length > 0) {
        if (body.sitesIds && body.siteIds.length > 0) {
          body.siteIds.push(this.specificSiteId[0]);
        } else {
          body.siteIds = this.specificSiteId;
        }
      }

      body.activityId = this.activityId;

      const activityDataCollected = this.analyteFilters;
      const updateIndex = activityDataCollected.findIndex(filter => filter == "FEV1 FVC");
      activityDataCollected[updateIndex] = "FEV1/FVC";

      body.activityDataCollected = activityDataCollected;

      // Api endpoint call
      const data = await this.$api.getDailySpirometerReading(params, body);

      //response = data;

      if (data.ok) {
        const result = data.body;

        if (result.data !== {}) {
          response = result.data;
        }
      }

      this.isLoading = false;
      return response;
    },

    async getEdroActivities() {
      this.isLoading = true;

      const params = {
        studyId: this.studyId
      };

      let forcedSpirometryObj = {};
      forcedSpirometryObj.filters = [];
      try {
        const res = await this.$api.getEdroActivities(params);
        if (res.ok) {
          const result = res.body;
          if (!_isEmpty(result.data)) {
            if (result.data.activities && result.data.activities.length > 0) {
              forcedSpirometryObj = result.data.activities.find(obj => obj.activityTitle == "Forced Spirometry");
            }
          }
        }
      } catch (err) {}
      this.isLoading = false;
      return forcedSpirometryObj;
    },

    async getAllParticipantSiteIds() {
      this.isLoading = true;
      let response = null;

      const params = {
        studyId: this.studyId
      };

      if (this.specificSiteId && this.specificSiteId.length > 0) {
        params.siteId = this.specificSiteId[0];
      }

      const data = await this.$api.getAllUsers(params);

      if (data.ok) {
        const result = data.body;
        if (result.data !== {}) {
          response = _.orderBy(Array.from(result.data), [participant => (participant.userDefinedId ? participant.userDefinedId.toLowerCase() : participant.id.toLowerCase())]);
          response = response.filter(res => {
            return res.enrollmentDate;
          });
        }
      }

      this.isLoading = false;
      return response;
    },

    async getAllSites() {
      this.isLoading = true;
      let response = null;
      try {
        const res = await this.$api.getSitesFact(this.studyId);
        if (res.ok) {
          const result = res.body;
          if (!_isEmpty(result)) {
            response = result;
          }
        }
      } catch (err) {}
      this.isLoading = false;
      return response;
    },

    async callApi(turnOffGlobalLoader = false, filterBy) {
      let apiPromises = [];

      if (["mounted"].includes(filterBy)) {
        apiPromises = apiPromises.concat([
          await this.getAllParticipantSiteIds().then(raws => {
            this.allParticipantSiteIds = utils.getSiteIdsFromParticipantApi(raws);
            this.getAllSites().then(raws => {
              const res = utils.getSitesCountriesFromSitesApi(raws, this.allParticipantSiteIds, this.specificSiteId);
              this.tmpCountries = this.tmpCountries.concat(res.countryNames);
              this.tmpSites = this.tmpSites.concat(res.siteNames);
              this.siteIdNameMaps = res.siteIdNameMaps;
              this.countrySiteMaps = res.countrySiteMaps;
            });
          }),

          await this.getEdroActivities().then(async raws => {
            this.activityId = raws.activityId;
            this.analyteFilters = raws.filters;
            const updateIndex = this.analyteFilters.findIndex(filter => filter == "FEV1/FVC ratio");
            this.analyteFilters[updateIndex] = "FEV1 FVC";

            await this.getExpectedData()
              .then(raws => {
                this.expectedRawData = raws;
                this.expectedDataItems = forcedSpirometryService.expectedRecentDataItems(raws);
                this.dataLoaded.expectedData = true;
              })
              .catch(() => {
                this.expectedRawData = [];
                this.expectedDataItems = forcedSpirometryService.expectedRecentDataItems([]);
                this.dataLoaded.expectedData = true;
              });
            await this.getRecentData()
              .then(recentData => {
                this.recentRawData = recentData;
                this.recentDataItems = forcedSpirometryService.expectedRecentDataItems(recentData);
                this.dataLoaded.recentData = true;
              })
              .catch(() => {
                this.recentRawData = [];
                this.recentDataItems = forcedSpirometryService.expectedRecentDataItems([]);
                this.dataLoaded.recentData = true;
              });
            await this.getDailySpirometerReadingData()
              .then(raws => {
                this.dailySpirometerReadingRawData = raws;
                this.dataLoaded.dailySpirometerReading = true;
              })
              .catch(() => {
                this.dailySpirometerReadingRawData = [];
                this.dataLoaded.dailySpirometerReading = true;
              });
          })
        ]);
      }

      if (["participant"].includes(filterBy)) {
        apiPromises = apiPromises.concat([
          await this.getAllParticipantSiteIds().then(raws => {
            this.allParticipantSiteIds = utils.getSiteIdsFromParticipantApi(raws, this.participantsSelected);
            this.selectedSiteIds = this.allParticipantSiteIds;
            this.getAllSites().then(raws => {
              const res = utils.getSitesCountriesFromSitesApi(raws, this.allParticipantSiteIds, this.specificSiteId);
              this.countrySelected = res.countryNames;
              this.sitesSelected = res.siteNames;
            });
          })
        ]);
      }

      if (["country", "site", "date", "participant"].includes(filterBy)) {
        apiPromises = apiPromises.concat([
          await this.getExpectedData()
            .then(raws => {
              this.expectedRawData = raws;
              this.expectedDataItems = forcedSpirometryService.expectedRecentDataItems(raws);
              this.dataLoaded.expectedData = true;
            })
            .catch(() => {
              this.expectedRawData = [];
              this.expectedDataItems = forcedSpirometryService.expectedRecentDataItems([]);
              this.dataLoaded.expectedData = true;
            }),

          await this.getRecentData()
            .then(recentData => {
              this.recentRawData = recentData;
              this.recentDataItems = forcedSpirometryService.expectedRecentDataItems(recentData);
              this.dataLoaded.recentData = true;
            })
            .catch(() => {
              this.recentRawData = [];
              this.recentDataItems = forcedSpirometryService.expectedRecentDataItems([]);
              this.dataLoaded.recentData = true;
            }),

          await this.getDailySpirometerReadingData()
            .then(raws => {
              this.dailySpirometerReadingRawData = raws;
              this.dataLoaded.dailySpirometerReading = true;
            })
            .catch(() => {
              this.dailySpirometerReadingRawData = [];
              this.dataLoaded.dailySpirometerReading = true;
            })
        ]);
      }

      await Promise.all(apiPromises);

      this.callApiCompleted = true;

      this.expectedDataFields = forcedSpirometryService.expectedDataFields();
      this.generateRecentDataFields();
      if (turnOffGlobalLoader) {
        await this.turnOffGlobalLoader();
      }
    },
    generateRecentDataFields() {
      const widthStyle = this.zoomGraphValue == "recent-data" ? "minWidth" : "width";
      this.recentDataFields = forcedSpirometryService.recentDataFields(widthStyle, this.analyteFilters);
    },
    zoomEnabled(chart) {
      this.zoomGraphValue = chart;
      if (chart == "recent-data") {
        this.generateRecentDataFields();
      }
    },
    zoomDisabled() {
      this.zoomGraphValue = "";
      this.generateRecentDataFields();
    },

    onScrollRecentDataTable() {
      this.pageNum++;
      this.getRecentData().then(recentData => {
        this.recentRawData.push(...recentData);
        this.recentDataItems = forcedSpirometryService.expectedRecentDataItems(this.recentRawData);
      });
    }
  },
  async mounted() {
    document.body.classList.add("forced-spirometry");
    this.$router.push({ query: { automatic_off_loader: false } });
    this.studyId = this.$route.params.studyId;
    await this.prepareDatePicker();

    this.specificSiteId = _get(this.user, "siteIds", []);
    await this.callApi(true, "mounted");
  },
  computed: {
    ...mapGetters(["user"])
  },
  watch: {
    tmpCountries: function(val) {
      let newVal = val;
      if (newVal.length == 0 && this.specificSiteId && this.specificSiteId.length > 0) {
        if (this.user && this.user.countries && this.user.countries.length > 0) {
          const country = this.user.countries[0];
          if (country) {
            newVal = [country.name];
          }
        }
      }
      const allCountries = _.uniq(newVal);
      this.countryList = _.orderBy(Array.from(allCountries), [country => country.toLowerCase()]);
    },

    tmpSites: function(val) {
      let newVal = val;
      if (newVal.length == 0 && this.specificSiteId && this.specificSiteId.length > 0) {
        if (this.studyData.sitesInfo && this.studyData.sitesInfo.length > 0) {
          const site = this.studyData.sitesInfo.find(obj => obj.id == this.specificSiteId[0]);
          if (site) {
            this.siteIdNameMaps = [{ id: site.id, name: site.name }];
            if (this.countryList.length > 0) {
              this.countrySiteMaps = [{ country: this.countryList[0], sites: [site.name] }];
            }
            newVal = [site.name];
          }
        }
      }
      const allSites = _.uniq(newVal);
      this.allSitesList = _.orderBy(Array.from(allSites), [site => site.toLowerCase()]);
    },

    sitesSelected: function(val) {
      this.selectedSiteIds = utils.getSiteIdsBySiteNames(this.siteIdNameMaps, val);
    }
  },
  destroyed() {
    document.body.classList.remove("forced-spirometry");
  }
};
</script>
